/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import Tippy from '@tippyjs/react';
import * as React from 'react';
import {
  components as SelectComponents,
  GroupTypeBase,
  OptionTypeBase,
  SingleValueProps,
  StylesConfig,
} from 'react-select';

import { userSelectStyles } from './user';

export const RepeatPeriodTypeLabels = {
  none: (helptext = 'None') => <Tippy content={helptext} />,
  weekly: (helpText = 'Weekly') => <Tippy content={helpText} />,
  monthly: (helpText = 'Monthly') => <Tippy content={helpText} />,
  yearly: (helpText = 'Yearly') => <Tippy content={helpText} />,
  periodically: (helpText = 'Periodically') => <Tippy content={helpText} />,
  custom: (helpText = 'Custom') => <Tippy content={helpText} />,
};

export const renderRepeatPeriodTypes = {
  weekly: RepeatPeriodTypeLabels.weekly(),
  monthly: RepeatPeriodTypeLabels.monthly(),
  yearly: RepeatPeriodTypeLabels.yearly(),
  periodically: RepeatPeriodTypeLabels.periodically(),
  custom: RepeatPeriodTypeLabels.custom(),
};

export const repeatPeriodTypeOptions = [
  {
    label: 'Weekly',
    value: 'weekly',
  },
  {
    label: 'Monthly',
    value: 'monthly',
  },
  {
    label: 'Yearly',
    value: 'yearly',
  },

  {
    label: 'Custom',
    value: 'custom',
  },
];

export const getRepeatPeriodTypeLabel = {
  weekly: 'Weekly',
  monthly: 'Monthly',
  yearly: 'Yearly',
  custom: 'Custom',
};

type OptionType = OptionTypeBase & { label: string; value: string };
type GroupType = GroupTypeBase<OptionType>;

export const repeatPeriodTypeSelectStyles: StylesConfig<OptionType, boolean, GroupType> = {
  ...userSelectStyles,
  menuPortal: (base) => ({ ...base, zIndex: 1600 }),
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    ...(userSelectStyles?.option
      ? userSelectStyles?.option(styles, {
          isDisabled: isDisabled,
          isFocused: isFocused,
          isSelected: isSelected,
        } as any)
      : {}),

    padding: '1rem 1.5rem 1rem 1rem',
  }),
};

export const RepeatPeriodTypeSelectSingleValue:
  | React.ComponentType<SingleValueProps<OptionType, GroupType>>
  | undefined = (props) => (
  <div className="flex items-center">
    <span className="ml-8">{props.data.label}</span>
  </div>
);

export const RepeatPeriodTypeSelectOption: any = (props) => (
  <SelectComponents.Option {...props}>
    <div className="flex items-center">
      <span className="ml-8">{props.data.label}</span>
    </div>
  </SelectComponents.Option>
);
